export default __webpack_public_path__ + "static/media/job_filter_Icon.6fd49701.svg";